import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
 name: 'azureasset'
})

export class AzureAssetPipe implements PipeTransform {

transform(value: string): string {
    if (!value) return value;
    if (environment.production) {
      return `${environment.blobStorageUrl}/cdn/exhibitors-directory${value}`;
    }
    return value;
   }
}
